import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getCommissionsList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/commission-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createCommission = (data, token) => {
  return axios.post(`${baseUrl}/commission`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deleteCommission = (id, token) =>
  axios.delete(`${baseUrl}/commission/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateCommission = (id, data, token) =>
  axios.patch(`${baseUrl}/commission/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getCommissionById = (id, token) =>
  axios.get(`${baseUrl}/commission/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getPartners = (token) => {
  let url = `${baseUrl}/pmtpartner-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCompanyList = (token) => {
  let url = `${baseUrl}/company-list?stages=`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getupdatecommissionCompanyList = (token, name) => {
  let url = `${baseUrl}/company-list?stages=&partnername=${name}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
